import React, { FunctionComponent } from 'react';

// Libs
import classnames from 'classnames';

// Contexts
import { useViewDetected } from '@Components/Utils/ViewDetected';
import { usePostsManager } from '@Pages/bai-viet/Contexts/posts';

// Components
import Post from '@Components/UI/Post';
import Anchor from '@Components/Utils/Anchor';

// Styles
import styles from './PostsWithCategory.module.scss';

interface PostsWithCategoryProps {
    className?: string;
}

const PostsWithCategory: FunctionComponent<PostsWithCategoryProps> = ({ className }) => {
    const { posts } = usePostsManager();
    const { deviceType } = useViewDetected();

    const isMobile = deviceType !== 'desktop';

    const renderPostItem = () => {
        return posts.map((post) => (
            <Anchor
                key={`post-item-${post.id}`}
                className={styles.post_anchor}
                href={`/bai-viet/${post.slug || post.id}`}
            >
                <Post
                    isShowDescription
                    title={post?.title}
                    image={post?.image}
                    className={styles.post}
                    category={post?.category}
                    infoClassName={styles.info}
                    titleClassName={styles.title}
                    imageClassName={styles.image}
                    description={post?.description}
                    imagePosition={isMobile ? 'right' : 'left'}
                    imageWrapperClassName={styles.image_wrapper}
                />
            </Anchor>
        ));
    };

    const wrapper = classnames([
        styles.wrapper,
        {
            [styles.mobile]: isMobile,
        },
        className,
    ]);

    return <div className={wrapper}>{renderPostItem()}</div>;
};

PostsWithCategory.defaultProps = {
    className: '',
};

export default PostsWithCategory;
